// extracted by mini-css-extract-plugin
export default {"zoomModal":"_2-z"};